import { createAsyncThunk } from '@reduxjs/toolkit';
import QueryString from 'qs';
import { TApiaFilter } from '../../../../../types';
import { TAsyncThunkState } from '../../../types';
import { notify } from '../../../../../components/common/notifications/util';
import { listActions } from '../../..';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import { ApiaUtil } from '@apia/components';

export type TUpdateFilters = {
  listId: string;
  filters?: TApiaFilter[];
  forceAjaxUrl?: boolean;
  forceTabId?: boolean;
  onlyRedux?: boolean;
};

const setFilters = createAsyncThunk<
  TApiaFilter[] | undefined,
  TUpdateFilters,
  TAsyncThunkState
>(
  'listSlice/setFilters',
  async (
    { listId, filters, forceAjaxUrl = false, forceTabId = false, onlyRedux },
    thunkApi,
  ) => {
    const state = thunkApi.getState().listSlice.lists[listId];
    const { dispatch } = thunkApi;

    /**
     * La siguiente logica se encarga de detecctar si todos los filtros
     * requeridos fueron ingresados. De ser asi o si no hay filtros requeridos,
     * isRequirementSet deberia cambiar a true
     */
    let isRequirementSet = false;
    let required = 0;
    let withValue = 0;

    if (filters) {
      state.filters?.forEach((filter) => {
        if (filter.required) {
          required++;
          if (
            filter.currentValue !== '' ||
            filters.findIndex((innerFilter) => {
              return innerFilter.id === filter.id;
            }) !== -1
          ) {
            withValue++;
          }
        }
      });
      filters.forEach((filter) => {
        if (filter.required) {
          required++;
          if (filter.currentValue !== '') {
            withValue++;
          }
        }
      });
    }
    if (required === withValue) isRequirementSet = true;

    /**
     * La siguiente logica se encarga de guardar en newFilters cada filtro en
     * el estado con los cambios de valor realizados
     */

    const newFilters = filters
      ? state.filters?.map((currentFilter) => {
          let updatingFilter: TApiaFilter | undefined = filters.find(
            (searchFilter) => {
              if (searchFilter.id === currentFilter.filterToId) {
                return searchFilter.id === currentFilter.filterToId;
              }

              return searchFilter.id === currentFilter.id;
            },
          );
          if (updatingFilter) {
            if (['date', 'D'].includes(currentFilter.type as string)) {
              updatingFilter = {
                ...currentFilter,
                currentValue: updatingFilter.currentValue,
                filterToValue: updatingFilter.filterToValue,
                deleteFiltersTimestamp: updatingFilter.deleteFiltersTimestamp,
                changeFiltersTimestamp: updatingFilter.changeFiltersTimestamp,
                errorFrom:
                  !!updatingFilter.currentValue &&
                  currentFilter.errorFrom === 'Filtro requerido' &&
                  updatingFilter.errorFrom === undefined
                    ? undefined
                    : updatingFilter.errorFrom
                      ? updatingFilter.errorFrom
                      : !updatingFilter.currentValue &&
                          currentFilter.errorFrom === 'Filtro requerido'
                        ? currentFilter.errorFrom
                        : undefined,
                errorTo:
                  !!updatingFilter.filterToValue &&
                  currentFilter.errorTo === 'Filtro requerido' &&
                  updatingFilter.errorTo === undefined
                    ? undefined
                    : updatingFilter.errorTo
                      ? updatingFilter.errorTo
                      : !updatingFilter.filterToValue &&
                          currentFilter.errorTo === 'Filtro requerido'
                        ? currentFilter.errorTo
                        : undefined,
                error:
                  !!updatingFilter.filterToValue &&
                  !!updatingFilter.currentValue &&
                  currentFilter.error === 'Filtro requerido' &&
                  updatingFilter.error === undefined
                    ? undefined
                    : updatingFilter.error
                      ? updatingFilter.error
                      : !(
                            !!updatingFilter.filterToValue &&
                            !!updatingFilter.currentValue
                          ) && currentFilter.error === 'Filtro requerido'
                        ? currentFilter.error
                        : undefined,
              };
            } else {
              updatingFilter = {
                ...currentFilter,
                currentValue: updatingFilter.currentValue,
                deleteFiltersTimestamp: updatingFilter.deleteFiltersTimestamp,
                changeFiltersTimestamp: updatingFilter.changeFiltersTimestamp,
                error:
                  !!updatingFilter.currentValue &&
                  currentFilter.error === 'Filtro requerido'
                    ? undefined
                    : currentFilter.error,
              };
            }

            return { ...currentFilter, ...updatingFilter };
          }

          return currentFilter;
        })
      : state.filters;

    /**
     * La siguiente logica se encarga de armar el payload que se enviara para
     * settear los filtros en el bean
     */

    const payloadFilters: Record<string, unknown> = {};

    newFilters?.forEach((currentFilter) => {
      payloadFilters[`${currentFilter.id}`] = currentFilter.currentValue;
      if (currentFilter.options) {
        currentFilter.options.forEach((option) => {
          if (option.selected) {
            payloadFilters[`${currentFilter.id}`] = option.value;
          }
        });
      }
      if (['date', 'D'].includes(currentFilter.type as string)) {
        payloadFilters[`${currentFilter.filterToId as string}`] =
          currentFilter.filterToValue;
      }
      if (
        (currentFilter.isRange || currentFilter.isSize) &&
        currentFilter.sizeMultiplier
      ) {
        payloadFilters[`${currentFilter.filterToId as string}`] = Math.round(
          ApiaUtil.instance.parsers.jsNumber(
            String(currentFilter.filterToValue),
          ) * currentFilter.sizeMultiplier,
        );

        payloadFilters[`${currentFilter.id as string}`] = Math.round(
          ApiaUtil.instance.parsers.jsNumber(
            String(currentFilter.currentValue),
          ) * currentFilter.sizeMultiplier,
        );
      }
    });
    if (!onlyRedux) {
      if (isRequirementSet) {
        await ApiaApi.post(
          makeApiaUrl({
            action: 'setFilters',
            preventAsXmlParameter: true,
            isAjax: true,
            ajaxUrl: forceAjaxUrl ? state.ajaxUrl : undefined,
            tabId: forceTabId ? state.tabId : undefined,
          }),
          {
            postData: QueryString.stringify(payloadFilters),
          },
        );
      } else {
        notify({
          message: window.MSG_FILTER_REQUIRED,
          type: 'warning',
        });
        void dispatch(
          listActions.setState({
            listId,
            rows: [],
            customLabel: window.MSG_FILTER_REQUIRED,
          }),
        );
      }
    }
    return newFilters;
  },
);

export default setFilters;
